import { render, staticRenderFns } from "./Evergreen.vue?vue&type=template&id=e5020b06&scoped=true&"
import script from "./Evergreen.vue?vue&type=script&lang=js&"
export * from "./Evergreen.vue?vue&type=script&lang=js&"
import style0 from "./Evergreen.vue?vue&type=style&index=0&id=e5020b06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5020b06",
  null
  
)

export default component.exports